import { Typography } from "@mui/material";
import React from "react";
import { useProcessingActivityStatisticsStyles } from "../processingActivityStatistics.styles";
import { useTranslation } from "../../../localization/useTranslation";
import DotLegalPaper from "../../../common/components/dotLegalPaper/DotLegalPaper";

export interface DraftSubmittedToActiveAverageProps {
    submittedToActiveAverage: number | undefined;
}

function DraftSubmittedToActiveAverage(props: DraftSubmittedToActiveAverageProps) {
    const styles = useProcessingActivityStatisticsStyles();
    const { translateString } = useTranslation();
    return (
        <DotLegalPaper backgroundColor="pink" fullHeight>
            <Typography sx={styles.header}>{translateString("draftSubmittedToActiveAverage")}</Typography>
            <Typography sx={styles.body}>
                {props?.submittedToActiveAverage} {translateString("days").toLowerCase()}
            </Typography>
        </DotLegalPaper>
    );
}

export default DraftSubmittedToActiveAverage;
